import { useNavigate } from 'react-router-dom';

import { useCreateTaskMutation } from '../api';

import type { MessageCreateModel } from '@/features/Shared';
import type { SubmitHandler } from 'react-hook-form';

import { CreateFormLayout } from '@/features/Shared/forms';

export const CreateTaskLayout = () => {
	const navigate = useNavigate();
	const [create] = useCreateTaskMutation();

	const handleSubmit: SubmitHandler<MessageCreateModel> = async (data) => {
		try {
			await create(data).unwrap();
			navigate('/tasks');
		} catch {
			// Handle error (e.g., show a notification)
		}
	};

	return (
		<CreateFormLayout
			title="Create Task"
			buttonText="Send Task"
			value={{
				content: {
					title: {
						text: '',
					},
					body: {
						text: '',
					},
				},
				recipientGroups: [],
			}}
			onSubmit={handleSubmit}
		/>
	);
};
